import {get} from '../utils'
import {getActiveChannel, getActiveClient, getStoredChannel} from "../authentication/utils";
import localization from '../../../config/localization';

export default host => (contentCreatorId, tagGroup = null, isAudiovisual = false) =>
  get(`${host}${(getStoredChannel() && getStoredChannel().visibility === "public") ? "/public": ""}/clients/${getActiveClient()}/${getActiveChannel() ? `channels/${getActiveChannel()}/` : ""}contentCreators/${contentCreatorId}/suggested?include=image;type${tagGroup ? `&tagGroup=${tagGroup}` : ""}&type=${isAudiovisual ? `audiovisual` : "editorial"}${getActiveChannel() ? `&cLang=${localization.getLanguage()}` : ""}`)
    .then(response => response.json())
    .then(json => json.data)
